<template>
  <Layout>
    <h3 class="page-title">{{$t('notifications_title')}}</h3>
    <div class="filter-wrapper">
      <div class="filter-row">
        <div class="tab-panel-row">
          <div class="tab-panel">
            <button class="tab-button" :class="{'active': tabIndex === 0}" @click="() => changeTab(0)">
              <span>{{$t('templates')}}</span>
            </button>

            <button class="tab-button" :class="{'active': tabIndex === 1}" @click="() => changeTab(1)">
              <span>{{$t('sent')}}</span>
            </button>
          </div>
        </div>
      </div>


      <div class="justify-end-div">
        <TableDownload
            :data="pageData.data"
            :fields="['content.label', 'types', 'status', 'sendDate']"
            :headers="{
              'content.label': $t('name_journeys'),
              'types': $t('types'),
              'status': $t('status'),
              'sendDate': $t('send_date')
            }"
            :computed-fields="{
              'types': (item) => item.types ? item.types.join(', ') : '-',
              'status': (item) => item.status ? $t('active') : $t('draft'),
              'sendDate': (item) => formatDate(item.sendDate)
            }"
            :filename="$t('notifications_report')"
        />
        <ExpandableSearch />
        <div class="log-icon-wrapper">
          <img src="@/assets/images/logIconNew.svg" @click="showLogModal" class="log-icon" />
          <span class="tooltip">{{ $t('log_records') }}</span>
        </div>
        <LogModal
            :visible="isLogModalVisible"
            :on-hide="hideLogModal"
            :data="logData"
            :total-items="logMeta.total"
            :current-page="logMeta.currentPage"
            :per-page="logMeta.perPage"
            :on-page-change="handleLogPageChange"
        />
        <router-link to="/notification/new">
          <div class="justify-end-add-btn no-text-select">
            <img src="../assets/images/plus.svg" />
            <span>{{$t('add_new')}}</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="table-holder">
      <NotificationTable
          :data="pageData.data"
          :loading="isLoading"
          :current-sort="currentSort"
          :on-sort="handleSort"
      />
    </div>

    <div class="pagination-align-center">
      <Pagination :current-page="currentPage" :total-items="pageData.total" :per-page="20" :on-page-change="handlePage"/>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import Pagination from "@/components/Pagination.vue";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import {handleErrorResponse} from "@/utils/utils";
import PageCard from "@/components/PageCard.vue";
import notificationContentService from "@/service/notificationContentService";
import NotificationTable from "@/components/tables/Notifications/NotificationTable.vue";
import LogModal from "@/components/modals/LogModal.vue";
import TableDownload from "@/components/TableDownload.vue";

export default {
  name: 'Notifications',
  components: {
    TableDownload,
    LogModal,
    NotificationTable,
    PageCard,
    ExpandableSearch,
    Pagination,
    Layout
  },
  data() {
    return {
      logData: [],
      logMeta: {
        total: 0,
        currentPage: 1,
        perPage: 20
      },
      isLogModalVisible: false,
      isLoading: true,
      tabIndex: 0,
      pageData: {
        data: [],
        total: 0
      },
      currentPage: 1,
      currentSort: {
        column: null,
        direction: null
      }
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },
  mounted() {
    // getLogs kaldırıldı - modal açılınca çağrılacak
    this.handlePage(1);

    // URL'den sort parametrelerini oku
    const routeQuery = this.$route.query;
    if (routeQuery.sortBy && routeQuery.sortDirection) {
      this.currentSort = {
        column: routeQuery.sortBy,
        direction: routeQuery.sortDirection
      };
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    handleSort(column, direction) {
      this.currentSort = {
        column: column,
        direction: direction
      };

      const query = { ...this.$route.query };

      if (column && direction) {
        query.sortBy = column;
        query.sortDirection = direction;
      } else {
        delete query.sortBy;
        delete query.sortDirection;
      }

      this.$router.push({ query });
      this.handlePage(1);
    },

    getLogs(page = 1) {
      notificationContentService.getLogs(this.$i18n.locale, page, 20).then((res) => {
        const response = res.data.data;
        this.logData = response.data;
        this.logMeta = {
          total: response.total,
          currentPage: response.current_page,
          perPage: response.per_page
        };
      }).catch((err) => {
        handleErrorResponse(err, this.$snackbar);
      });
    },

    handleLogPageChange(page) {
      if (this.logMeta.currentPage === page) return;
      this.logMeta.currentPage = page;
      this.getLogs(page);
    },

    showLogModal() {
      this.isLogModalVisible = true;
      this.logMeta.currentPage = 1;
      this.getLogs(1);
    },

    hideLogModal() {
      this.isLogModalVisible = false;
    },

    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;

      this.currentPage = page;
      this.isLoading = true;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.isTemplate) {
        tempFilters.push({
          key: 'isTemplate',
          value: routeQuery.isTemplate
        });
      } else {
        tempFilters.push({
          key: 'isTemplate',
          value: true
        });
      }

      if (routeQuery.journeyId) {
        tempFilters.push({
          key: 'journeyId',
          value: routeQuery.journeyId
        });
      }

      if (routeQuery.sortBy && routeQuery.sortDirection) {
        const orderByArray = [{
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        }];

        tempFilters.push({
          key: 'orderBy',
          value: orderByArray
        });

        this.currentSort = {
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        };
      }

      notificationContentService.getNotificationContent(page, tempFilters)
          .then(response => {
            this.pageData = response.data.data;
            this.isLoading = false;
          })
          .catch(error => {
            handleErrorResponse(error);
            this.isLoading = false;
          });
    },

    changeTab(index) {
      if (this.tabIndex === index) {
        return;
      }

      this.tabIndex = index;

      if (index === 0) {
        this.$router.push({query: {
            ...this.$route.query,
            isTemplate: true
          }});
      } else {
        this.$router.push({query: {
            ...this.$route.query,
            isTemplate: false
          }});
      }
    }
  }
}
</script>

<style scoped>
.tab-panel {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: row;
}

.tab-panel-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.tab-button {
  padding: 6px 10px;
  border-radius: 10px;
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
}
.tab-button span {
  font-family: 'euclid_medium', sans-serif;
  font-size: 12px;
  color: #344054;
}
.tab-button.active, .tab-button:hover {
  background-color: #F2F4F7;
}

.page-title {
  font-family: euclid_medium, sans-serif;
  font-size: 20px;
  color: #040C2D;
  margin-bottom: 20px;
}
.filter-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.filter-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
</style>
